<template>
  <div
    class="relative w-100 h-100 header-spacer home bg-beige"
    :class="{ 'is-reduced': headerSpacerIsReduced }"
  ></div>
</template>

<script>
import { bus } from "../../assets/js/src/main";
export default {
  components: {
    //
  },
  props: {
    //
  },
  data() {
    return {
      headerSpacerIsReduced: false,
    };
  },
  computed: {
    //
  },
  methods: {
    //
  },
  created() {
    bus.$on("messageBarClosed", () => {
      //console.log('messageBarClosed: ');
      this.headerSpacerIsReduced = true;
    });
  },
  mounted() {
    //
  },
  watch: {
    /*
      $route (to, from) {
        //
      }
      */
  },
  beforeDestroy() {
    //
  },
  updated() {
    //
  },
};
</script>
